export const SUBJECT_ID = 'fraudId';
export const INCIDENT_ID = 'incidentId';
export const REFUND_ID = 'refundId';
export const USER_ID = 'id';
export const DICTIONARY_NAME = 'dictionaryName';
export const DICTIONARY_ITEM_ID = 'dictionaryItemId';
export const TRANSACTION_ID = 'transactionId';
export const TRANSACTION_INDEX = 'transactionIndex';
export const CLASSIFICATION_TYPE = 'classification_type';
export const CLASSIFICATION_SUBTYPE = 'classification_subtype';
export const INCIDENT_TYPE_CODE = 'incidentTypeCode';
export const FAQ_ID = 'faqId';
export const MSISDN_ID = 'msisdnId';
export const CONTACT_DETAILS_ID = 'contactDetailsId';
export const MSISDN_FRAUD_ENTRY_ID = 'entryId';
export const KNOWLEDGE_DOCUMENT_ID = 'documentId';
export const TOKEN = 'token';
export const ORGANIZATION_ID = 'organizationId';
export const ORGANIZATION_DOCUMENT_ID = 'organizationDocumentId';
export const DASHBOARD_ID = 'dashboardId';
export const DASHBOARD_SECTION = 'section';
export const TREND_ID = 'trendId';
export const FRAUD_REPORT_TYPE = 'fraudReportType';
export const FRAUD_REPORT_ID = 'fraudReportId';
